import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BundleData, InnovationsDataItem } from 'client/bundles/types';

import AboutInnovationsCards from 'client/components/about-innovations-cards';
import Breadcrumbs from 'client/components/breadcrumbs';
import SectionShiftTitle from 'client/components/section-shift-title';
import Seo from 'client/components/seo';
import WideStripe from 'client/components/wide-stripe';
import LangContext from 'client/utils/lang-context';

import './index.css';

const b = cn('about-innovations');
const bPageTitle = cn('page-title');
const bPageText = cn('page-text');

interface Props {
    data: BundleData;
}

export default class AboutInnovationsPage extends Component<Props> {
    static contextType = LangContext;

    renderSelfDrivingCards = (data: InnovationsDataItem[]) => (
        <AboutInnovationsCards data={data} theme="white" />
    )

    renderDeliveryRobotsCards = (data: InnovationsDataItem[]) => (
        <AboutInnovationsCards data={data} theme="blue" />
    )

    render() {
        const { title, text, image, selfDriving, deliveryRobots } = this.props.data.aboutInnovations;
        const { dictionary } = this.context;

        return (
            <>
                <Seo title={title} />

                <div className={b()}>
                    <Breadcrumbs link="/about" text={dictionary.about} />

                    <h1 className={bPageTitle({ type: 'border' })}>{title}</h1>
                    <div className={bPageText()} dangerouslySetInnerHTML={{ __html: text }} />

                    <WideStripe isBanner background="gradient">
                        <picture>
                            <source srcSet={image['banner-desktop']} media="(min-width: 768px)" />
                            <img src={image['banner-phone']} className={b('image')} />
                        </picture>
                    </WideStripe>

                    <WideStripe>
                        <SectionShiftTitle
                            title={selfDriving.title}
                            childrenSecond={this.renderSelfDrivingCards(selfDriving.data)}
                            />
                    </WideStripe>

                    <div className={b('delivery-robots')}>
                        <SectionShiftTitle
                            title={deliveryRobots.title}
                            childrenSecond={this.renderDeliveryRobotsCards(deliveryRobots.data)}
                            />
                    </div>
                </div>
            </>
        );
    }
}
